export const P00058CapteurTemperatureEnum = [
  {
    ref: 0,
    label: 'P00058.installation.prevention.capteurTemperature.0',
    visible: true,
  },
  {
    ref: 1,
    label: 'P00058.installation.prevention.capteurTemperature.1',
    visible: true,
  },
];
